// extracted by mini-css-extract-plugin
module.exports = {"header":"ImageGalleryPage_header__2o3oW","imageGrid":"ImageGalleryPage_imageGrid__2LH0g","imgWrapper":"ImageGalleryPage_imgWrapper__3bphY"};